import {
    Menu,
    Plus
} from "lucide-react";

export default function BuilderMobileHeader({

    title = "Builder Library",

    action,

    actionLabel = "Upload",

    onMenu,

    onAction

}){

    return(

        <header className="media-mobile-header">

            <button

                className="media-mobile-btn"

                onClick={onMenu}

                aria-label="Open Menu"

            >

                <Menu size={22}/>

            </button>

            <div className="media-mobile-title">

                {title}

            </div>

            {

                action

                ?

                action

                :

                <button

                    className="media-mobile-action"

                    onClick={onAction}

                >

                    <Plus size={18}/>

                    <span>

                        {actionLabel}

                    </span>

                </button>

            }

            <style>{`

.media-mobile-header{

    display:none;

    align-items:center;

    justify-content:space-between;

    gap:12px;

    position:sticky;

    top:0;

    z-index:102 !important;

    height:64px;

    padding:0 18px;

    background:#FFF;

    border-bottom:1px solid #E5E7EB;

}

.media-mobile-btn{

    width:42px;

    height:42px;

    border:none;

    border-radius:12px;

    background:#F8FAFC;

    display:flex;

    justify-content:center;

    align-items:center;

    cursor:pointer;

    transition:.18s;

}

.media-mobile-btn:hover{

    background:#EEF2F7;

}

.media-mobile-title{

    flex:1;

    overflow:hidden;

    text-overflow:ellipsis;

    white-space:nowrap;

    font-size:18px;

    font-weight:700;

    color:#111827;

}

.media-mobile-action{

    height:40px;

    padding:0 14px;

    border:none;

    border-radius:10px;

    background:#2563EB;

    color:#FFF;

    display:flex;

    align-items:center;

    gap:8px;

    font-size:14px;

    font-weight:600;

    cursor:pointer;

    transition:.18s;

}

.media-mobile-action:hover{

    background:#1D4ED8;

}

@media(max-width:992px){

.media-mobile-header{

    display:flex;

}

}

@media(max-width:480px){

.media-mobile-action{

    width:40px;

    padding:0;

    justify-content:center;

}

.media-mobile-action span{

    display:none;

}

}

`}</style>

        </header>

    );

}